import { Group, Text } from "@mantine/core"
import { RingProgress } from "@tfg/ui"
import { useMemo } from "react"

interface Props {
  ratio: number
}

export const SupplierListProgressBar = ({ ratio }: Props) => {
  const percentage = useMemo(() => {
    return Math.round(ratio * 100)
  }, [ratio])
  return (
    <Group wrap="nowrap">
      <RingProgress
        rootColor="var(--progress-bar-color-unfilled)"
        sections={[
          {
            value: percentage,
            color: "var(--progress-bar-color-filled)",
          },
        ]}
        thickness={10}
        label={
          <Text fw={700} ta="center" size="xl">
            {percentage}%
          </Text>
        }
      />
    </Group>
  )
}
